import React from "react";
import { useEffect } from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

import Image from "next/image";
import Link from "next/link";
import AOS from "aos";

import Pro29 from "@/public/static/images/project_29.jpg";
import Pro30 from "@/public/static/images/project_30.png";

function itp_itic() {
  AOS.init({
    offset: 200,
    duration: 600,
    easing: "ease-in-out-sine",
    delay: 200,
    mirror: true,
  });

  return (
    <div className="wrapper">
      <Header />
      <section className="proj">
        <div className="container">
          <div className="row">
            <div className="col-12 project_box">
              <div className="row">
                <div className="col-12 col-md-7 order-md-1 order-2">
                  <div>
                    <div className="project-heading">
                      <h1 className="t-yellow text-unset">
                        ITP ASIA x iTIC
                      </h1>
                    </div>
                  </div>
                  {/* <div className="badge_box">
                    <Link href="/ourservice/web_application">
                      <span className="badge rounded-pill text-bg-light">
                        AI Translation
                      </span>
                    </Link>
                    <Link href="/ourservice/web_application">
                      <span className="badge rounded-pill text-bg-light">
                        Collaboration
                      </span>
                    </Link>
                  </div> */}
                  <div className="project_content-inner project-list">
                    <p>
                      iTIC, also known as the Intelligent Traffic Information{" "}
                      <br />
                      Center Foundation, is Link non-profit organization
                      dedicated <br />
                      to delivering up-to-date traffic information across
                      Thailand.
                    </p>
                  </div>
                </div>
                <div className="col-12 col-md-5 order-md-2 order-1">
                  <Image
                    loading="lazy"
                    src={Pro29}
                    alt="ITP Asia x iTIC"
                    className="img-fluid mx-auto "
                  />
                </div>
              </div>
            </div>

            <div className="col-12 project_content">
              <div className="row mb-5">
                <div className="col-12 col-md-6 mb-3 project_content-inner order-md-1 order-2">
                  <Image
                    loading="lazy"
                    src={Pro30}
                    alt="ITP Asia x iTIC"
                    className="img-fluid px-5 mb-3"
                  />
                </div>

                <div className="col-12 col-md-6 mb-3 project_content-inner order-md-2 order-1">
                  <div className="project_content-inner mb-5">
                    <h2 className="t-yellow mb-2">Function</h2>
                    <p>
                      AI translation support for Thai to English translation of
                      traffic information.Offer API to combine with iTIC system.
                    </p>
                  </div>

                  <div className="project_content-inner mb-5">
                    <h2 className="t-yellow mb-2">Background</h2>
                    <p className="mb-3">
                      iTIC provides both Thai and English traffic information
                      through their website.The operators face the problem to
                      translate big volume of Thai information to correct
                      English swiftly at real time.
                    </p>
                  </div>

                  <div className="project_content-inner mb-5">
                    <h2 className="t-yellow mb-2">Result</h2>
                    <p className="mb-3">
                      With our API, iTIC operators can translate traffic
                      information from Thai to English more accurately and
                      launch the English information more swiftly.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default itp_itic;
